/* idle-help.js — 2min idle popup that opens Shopify Inbox chat */
(function() {
  // ====== Config ======
  var IDLE_MS = 2 * 60 * 1000; // 2分钟
  // var IDLE_MS = 5000; // 2分钟
  var STORAGE_KEY_SESSION = 'idleHelpShownSession';
  var STORAGE_KEY_DAY = 'idleHelpShownAt';

  // ====== Utils ======
  function now() { return Date.now(); }
  function markShown() {
    try {
      sessionStorage.setItem(STORAGE_KEY_SESSION, '1');
      localStorage.setItem(STORAGE_KEY_DAY, String(now()));
    } catch(e) {}
  }
  function shouldShow() {
    try {
      if (sessionStorage.getItem(STORAGE_KEY_SESSION) === '1') return false; // 每个会话只弹一次
      var last = parseInt(localStorage.getItem(STORAGE_KEY_DAY) || '0', 10);
      if (now() - last < 24*60*60*1000) return false; // 24 小时内最多弹一次
    } catch(e) {}
    return true;
  }

  // ====== 打开 Shopify Inbox（Shopify Chat）======
  function openShopifyInbox() {
    // 1) 极少数主题会挂出 window.Shopify.chat.open()
    try {
      if (window.Shopify && window.Shopify.chat && typeof window.Shopify.chat.open === 'function') {
        window.Shopify.chat.open(); 
        return true;
      }
    } catch(e) {}

    // 2) 常规稳定做法：点击 Web Component (#ShopifyChat) 的 shadowRoot 内部按钮
    try {
      var getWidget = function() {
        return document.getElementById('ShopifyChat') || document.querySelector('shopify-chat, #shopify-chat, #ShopifyChat');
      };
      var clickInner = function(el) {
        if (!el || !el.shadowRoot) return false;
        var btn = el.shadowRoot.querySelector('.chat-app>button, button[aria-label*="Open chat"], button[aria-label*="Chat"]');
        if (btn) { btn.click(); return true; }
        return false;
      };

      var el = getWidget();
      if (clickInner(el)) return true;

      // 小部件可能稍后才挂载：重试最多 ~6 秒
      var attempts = 0;
      var iv = setInterval(function() {
        attempts++;
        var el2 = getWidget();
        if (clickInner(el2)) clearInterval(iv);
        if (attempts > 20) clearInterval(iv);
      }, 300);
      return true; // 安排了重试
    } catch(e) {}

    // 3) 其它客服（可留作备用；你现在用的是 Inbox，可忽略）
    try {
      if (window.tidioChatApi) { window.tidioChatApi.open(); return true; }
      if (typeof window.Intercom === 'function') { window.Intercom('show'); return true; }
      if (window.fcWidget && typeof window.fcWidget.open === 'function') { window.fcWidget.open(); return true; }
      if (window.zE) { window.zE('webWidget', 'open'); return true; }
      if (window.Beacon) { window.Beacon('open'); return true; }
      if (window.$crisp) { window.$crisp.push(['do', 'chat:open']); return true; }
    } catch(e) {}

    return false;
  }

  // ====== Modal 控制 ======
  function openModal() {
    var modal = document.getElementById('idle-help-modal');
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.documentElement.classList.add('idle-help-modal-open');
    (modal.querySelector('[data-idle-chat]') || modal.querySelector('[data-idle-close]'))?.focus();
  }
  function closeModal() {
    var modal = document.getElementById('idle-help-modal');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.documentElement.classList.remove('idle-help-modal-open');
  }

  // ====== 事件绑定 ======
  function bindUI() {
    document.addEventListener('click', function(e) {
      var t = e.target;
      if (t.closest('[data-idle-chat]')) {
        e.preventDefault();
        closeModal();
        openShopifyInbox(); // 直接拉起 Inbox
        markShown();
      } else if (t.closest('[data-idle-close]')) {
        e.preventDefault();
        closeModal();
        markShown();
      }
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  // ====== Idle 计时 ======
  var idleTimer;
  function resetTimer() {
    clearTimeout(idleTimer);
    if (shouldShow()) {
      idleTimer = setTimeout(function() {
        if (document.visibilityState === 'visible') openModal();
      }, IDLE_MS);
    }
  }

  ['mousemove','mousedown','keydown','scroll','touchstart','visibilitychange']
    .forEach(function(evt){ document.addEventListener(evt, resetTimer, {passive:true}); });

  bindUI();
  resetTimer();
})();
